import { IHttpService } from './IHttpService';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export class EndpointConfig {
    private static _staticBaseUrl = environment.production ? '' :
     
    //'https://localhost:7086'; 
    //'https://devapi.fleetdesks.com';
    'https://api.fleetdesks.com';
    private _baseUrl = environment.production ? '' : 
    
    //'https://localhost:7086';
    //'https://devapi.fleetdesks.com';
    'https://api.fleetdesks.com';
    constructor(public endpoint) { }

    public static getMvcUrl(controller, action, id?) {
        return `${this._staticBaseUrl}/api/${controller}/${action}${id == undefined ? '' : `/${id}`}`;
    }

    getEndPoint() {
        return `${this._baseUrl}/api/${this.endpoint}`;
    }

    getEndpointMethod(method) {
        return `${this._baseUrl}/api/${this.endpoint}/${method}`;
    }

    public getApiUrl() {
        return `${this._baseUrl}/api`;
    }

    public getControllerUrl(controllerName: string, actionName?: string) {
        return this.getApiUrl() + '/' + controllerName + (actionName ? '/' + actionName : '');
    }

}
